export default {
  authUser(state, data) {
    state.token = data.access_token;
    state.checkNewRegister = data.isNew;
  },

  setpanelToken(state, data) {
    state.token = data;
  },

  clearAuth(state) {
    state.token = null;
    state.registerToken = null;
    state.checkNewRegister = false;
  },

  setRegisterCode(state, data) {
    state.registerCode = data;
  },

  setRegisterAuth(state, data) {
    state.registerToken = data.access_token;
    state.checkNewRegister = data.isNew;
  },

  setForgotCode(state, data) {
    state.forgotCode = data;
  },

  setForgotCheck(state, data) {
    state.forgotCheck = data;
  },

  setLoadingBtn(state, data) {
    state.loadingBtn = data;
  },

  setProfile(state, data) {
    state.profile = data;
  },
  setAddress(state, data) {
    state.address = data;
  },

  setFactors(state, data) {
    state.factors = data;
  },
  setFactorById(state, data) {
    state.factorById = data;
  },

  setFactorDetail(state, data) {
    state.factorDetail = data;
  },


  setFavorites(state, data) {
    state.favorites = data;
  },
  setFavorite(state, data) {
    state.favorite = data;
  },

  setAvailableReturnProducts(state, data) {
    state.availableReturnProducts = data;
  },
  setReturns(state, data) {
    state.returns = data;
  },

  setTickets(state, data) {
    state.tickets = data;
  },
  setTicket(state, data) {
    state.ticket = data;
  },


  setPayBanks(state, data) {
    state.payBanks = data;
  },

  setFestivalDiscount(state, data) {
    state.festivalDiscount = data;
  },

  setPaymentResult(state, data) {
    state.paymentResult = data;
  },


};
